<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="classmate-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入商户名称" @keydown.enter="resetSearch">
            <template #prefix>名称</template>
          </el-input>
          <el-select v-model="searchInfo.searchType" placeholder="请选择商户类型" clearable>
            <template #prefix>类型</template>
            <el-option label="代理商户" :value="1"/>
            <el-option label="普通商户" :value="2"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="toShowEditMerchant({})">新建</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false" :show-border="false">
        <yq-table :data="merchantList" height="100%" stripe border >
          <yq-table-column  label="商户名称" prop="merchantName" :show-overflow-tooltip="true" min-width="180rem"/>
          <yq-table-column  label="负责人" prop="legalPerson" :show-overflow-tooltip="true" min-width="120rem"/>
          <yq-table-column  label="有效期" prop="validStart" :show-overflow-tooltip="true" width="180rem">
            <template v-slot="{row}">
              <yq-date-range v-model:start-time="row.validStart" v-model:end-time="row.validEnd" :disabled="true"/>
            </template>
          </yq-table-column>
          <yq-table-column  label="手机号" prop="merchantPhone" :show-overflow-tooltip="true" width="120rem"/>
          <yq-table-column  label="所属区域" prop="regionName" :show-overflow-tooltip="true" min-width="180rem">
            <template v-slot="{row}">
              <administrative v-model="row.regionCode" :disabled="true"/>
            </template>
          </yq-table-column>
          <yq-table-column  label="商户类型" prop="category" min-width="180rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">
              <span v-if="row.merchantType === 1">代理商户</span>
              <span v-else-if="row.merchantType === 2">普通商户</span>
              <span v-else-if="row.merchantType === 3">门店商户</span>
            </template>
          </yq-table-column>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" ::show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="管理商户">
                <table-button type="write" @click="toShowEditMerchant(row)">编辑</table-button>
                <table-button type="update" @click="router.push(`/merchant/info/detail?id=${row.id}`)">管理</table-button>
                <table-button type="delete" el-type="danger" message="是否确认删除数据" @click="toDeleteMerchant(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import PageButton from "@/components/h5/button/PageButton.vue";
import Administrative from "@/components/h5/data/Administrative.vue";
import YqDateRange from "@/components/h5/date/YqDateRange.vue";
import dictionaryApi from "@/api/normal/sys/dictionaryApi";
import merchantApi from "@/api/normal/sys/merchantApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "MerchantList",
  components: {
    YqDateRange, Administrative,
    PageButton,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage,
  },
  data() {
    return {
      searchInfo: {
        searchType: 1,
      },
      merchantList: [],
      showEditMerchant: false,
      editMerchant: {
        merchantName: "",
        validStart: "",
        validEnd: "",
        merchantDesc: "",
        legalPerson: "",
        address: "",
        merchantPhone: "",
        businessLicense: "",
        regionCode: "",
      },
      treeList: [],
      // 正在保存商户信息
      saveMerchantLoading: false,
      // 区域编码
      regionCodeList: [],

      // 操作列表树
      queryCategory: null,
      deleteCategory: null,
      saveCategory: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.queryCategory = dictionaryApi.queryUniqueTree;
    this.saveCategory = dictionaryApi.saveUniqueTreeNode;
    this.deleteCategory = dictionaryApi.deleteUnique;
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.resetSearch();
    }
  },
  methods: {
    queryList() {
      merchantApi.queryList(this.searchInfo).then(res => {
        this.merchantList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toShowEditMerchant(data) {
      this.router.push(`/merchant/info/editDetail?id=${data.id || ""}`)
    },
    toDeleteMerchant(data) {
      merchantApi.deleteMerchant(data.id).then(() => {
        this.queryList();
      })
    },
    clickCategory(dict) {
      this.searchInfo.category = dict.dictCode;
      this.resetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.classmate-list{
  height: 100%;
}
</style>